import React from 'react';
import { FiArrowDown, FiArrowUp, FiClock, FiCheck, FiX } from 'react-icons/fi';

export const TransactionStatusBadge = ({ status }) => {
  switch (status) {
    case 'completed':
      return (
        <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs flex items-center w-fit">
          <FiCheck className="mr-1" size={12} />
          Completed
        </span>
      );
    case 'pending':
      return (
        <span className="px-2 py-1 bg-yellow-100 text-yellow-800 rounded-full text-xs flex items-center w-fit">
          <FiClock className="mr-1" size={12} />
          Pending
        </span>
      );
    case 'failed':
      return (
        <span className="px-2 py-1 bg-red-100 text-red-800 rounded-full text-xs flex items-center w-fit">
          <FiX className="mr-1" size={12} />
          Failed
        </span>
      );
    default:
      return (
        <span className="px-2 py-1 bg-gray-100 text-gray-800 rounded-full text-xs flex items-center w-fit">
          {status || 'Unknown'}
        </span>
      );
  }
};

export const TransactionTypeIndicator = ({ type }) => {
  return type === 'credit' ? (
    <span className="flex items-center text-green-600">
      <FiArrowDown className="mr-1" />
      Credit
    </span>
  ) : (
    <span className="flex items-center text-red-600">
      <FiArrowUp className="mr-1" />
      Debit
    </span>
  );
};

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2
  }).format(amount || 0);
};

export const WithdrawalStatusBadge = ({ status }) => {
  switch (status) {
    case 'approved':
      return (
        <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs flex items-center w-fit">
          <FiCheck className="mr-1" size={12} />
          Approved
        </span>
      );
    case 'pending':
      return (
        <span className="px-2 py-1 bg-yellow-100 text-yellow-800 rounded-full text-xs flex items-center w-fit">
          <FiClock className="mr-1" size={12} />
          Pending
        </span>
      );
    case 'rejected':
      return (
        <span className="px-2 py-1 bg-red-100 text-red-800 rounded-full text-xs flex items-center w-fit">
          <FiX className="mr-1" size={12} />
          Rejected
        </span>
      );
    default:
      return (
        <span className="px-2 py-1 bg-gray-100 text-gray-800 rounded-full text-xs flex items-center w-fit">
          {status || 'Unknown'}
        </span>
      );
  }
};